import React, { forwardRef, ReactElement, Ref } from "react";
import { InputType } from "@Types/cart";
import "./style.scss";

export interface Props {
  autocomplete?: string;
  name: string;
  onChange?: (value: string) => void;
  onPaste?: boolean;
  pattern?: string;
  placeholder: string;
  required?: boolean;
  type?: InputType;
  value?: string | number | undefined;
}

const CartInput = forwardRef(
  (
    {
      autocomplete = "on",
      name,
      onChange,
      onPaste = true,
      pattern,
      placeholder,
      required = false,
      type = "text",
      value,
    }: Props,
    ref?: Ref<HTMLInputElement>
  ): ReactElement => {
    const handleChange = React.useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        if (onChange) {
          onChange(event.target.value);
        }
      },
      [onChange]
    );

    const handleKeyDown = React.useCallback((event: React.KeyboardEvent<HTMLInputElement>) => {
      switch (event.key) {
        case "Enter":
          event.preventDefault();
          break;
        default:
      }
    }, []);

    return (
      <div className="CartInput">
        <input
          autoComplete={autocomplete}
          className="CartInput-input"
          id={name}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onPaste={onPaste ? () => true : (e) => e.preventDefault()}
          pattern={pattern}
          placeholder="&nbsp;"
          ref={ref}
          required={required}
          tabIndex={0}
          type={type}
          value={value}
        />
        <label className="CartInput-label" htmlFor={name}>
          {`${placeholder}${required ? "*" : ""}`}
        </label>
      </div>
    );
  }
);

export default CartInput;
